import { render, staticRenderFns } from "./role.vue?vue&type=template&id=adda6084&scoped=true"
import script from "./role.vue?vue&type=script&lang=js"
export * from "./role.vue?vue&type=script&lang=js"
import style0 from "./role.vue?vue&type=style&index=0&id=adda6084&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import style1 from "./role.vue?vue&type=style&index=1&id=adda6084&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adda6084",
  null
  
)

export default component.exports